export function getInitials(firstName?: string | null, lastName?: string | null): string {
  const first = (firstName ?? '').charAt(0).toUpperCase();
  const last = (lastName ?? '').charAt(0).toUpperCase();
  return `${first}${last}`.trim() || '?';
}
